import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=5582f784&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=5582f784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5582f784",
  null
  
)

export default component.exports